import React from 'react';
import { X } from 'lucide-react';
import useGameStore from '@store/useGameStore';
import { GameStatus } from '@utils/enums';
import './PlannedActionDelete.css';

/**
 * Componente reutilizable para eliminar una acción planificada específica
 * Solo maneja la UI - la lógica de eliminación debe ser manejada por el componente padre
 */
export default function PlannedActionDelete({
  action,
  size,
  className = '',
  onDelete = null,
  showConfirm = false
}) {
  // ✅ Validate required props following CLAUDE.md - FAIL LOUDLY
  if (!action) {
    const error = new Error('[PlannedActionDelete] CRITICAL: action prop is required');
    console.error(error.message, {
      stack: error.stack,
      props: { action, size, className, onDelete, showConfirm }
    });
    throw error;
  }

  if (!size || typeof size !== 'number' || size <= 0) {
    const error = new Error(`[PlannedActionDelete] CRITICAL: size must be a positive number, got: ${size}`);
    console.error(error.message, {
      stack: error.stack,
      receivedSize: size,
      typeOfSize: typeof size,
      action: action
    });
    throw error;
  }

  // ✅ Check if we're in cinematic mode - hide delete buttons during cinematics
  const game = useGameStore((state) => state.game);
  const isCinematicMode = game?.status === GameStatus.Resolving || game?.status === GameStatus.Resolved;

  // ✅ Don't render delete buttons during cinematics
  if (isCinematicMode) {
    return null;
  }
  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!action?.id) {
      console.error("[PlannedActionDelete] ❌ Missing action data");
      return;
    }

    /*console.log("[PlannedActionDelete] 🎯 Delete button clicked for action:", {
      actionId: action.id,
      actionName: action?.action?.name || action?.name,
      unitId: action.unit_id
    });*/
    
    if (showConfirm) {
      const actionName = action?.action?.name || action?.name || 'Unknown Action';
      if (!window.confirm(`Cancel ${actionName}?`)) {
        return;
      }
    }

    // ✅ Solo llamar al callback del componente padre - no manejar la eliminación aquí
    if (onDelete) {
      onDelete(action);
    } else {
      console.warn("[PlannedActionDelete] ⚠️ No onDelete callback provided");
    }
  };

  return (
    <button
      className={`planned-action-delete ${className}`}
      onClick={handleClick}
      title={`Cancel ${action?.action?.name || action?.name || 'action'}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
      }}
    >
      <X size={size} />
    </button>
  );
}

